
import { films } from './MovieData';

export const getFilterOptions = () => {
  const getFilterCount = (category) => {
    if (category === "all") return films.length;
    return films.filter((film) => film.category === category).length;
  };

  return [
    { value: "all", label: "All Films", count: getFilterCount("all") },
    { value: "S", label: "Tier S (Masterpiece)", count: getFilterCount("S") },
    { value: "A", label: "Tier A (Excellent)", count: getFilterCount("A") },
    { value: "B", label: "Tier B (Great)", count: getFilterCount("B") },
    { value: "C", label: "Tier C (Good)", count: getFilterCount("C") },
  ];
};

export const getTypeFilterOptions = () => {
  const getTypeFilterCount = (type) => {
    if (type === "all") return films.length;
    return films.filter((film) => film.type === type).length;
  };

  return [
    { value: "all", label: "All Types", count: getTypeFilterCount("all") },
    { value: "movie", label: "Movies", count: getTypeFilterCount("movie") },
    { value: "series", label: "Series", count: getTypeFilterCount("series") },
    { value: "anime", label: "Anime", count: getTypeFilterCount("anime") },
  ];
};